// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"cb742c7a","949":"2a91d2e2"}[chunkId] + ".chunk.js";
};